import { Paper, List } from '@material-ui/core';
import Spin from 'components/Spin';
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useObservable } from 'react-use-observable';
import notificationService from 'v2/services/notifications';

import type { ENotificationType } from 'v2/interfaces/notification';

import ListItemNotification from './ListItemNotification';
import useStyle from './styles';

const ListNotification = () => {
  const classes = useStyle();
  const { type } = useParams<{ type: ENotificationType }>();
  const [notifications] = useObservable(() => notificationService.getListNotifications(type), [type]);
  const [isLoadingNotifications] = useObservable(() => notificationService.isLoadingNotifications(), []);

  useEffect(() => {
    const qs = new URLSearchParams(window.location.search);
    const readAll = qs.get('readAll');

    if (readAll === 'true') {
      return notificationService.readAllNotifications();
    }

    notificationService.readNotificationByType(type);
  }, [type]);

  if (isLoadingNotifications) return <Spin />;

  if (!notifications?.length) return <Paper className={classes.empty}>Não há notificações</Paper>;

  return (
    <List>
      {(notifications || []).map((n, index) => (
        <ListItemNotification key={index} notification={n} />
      ))}
    </List>
  );
};

export default ListNotification;
